let ua = window.navigator.userAgent
let ua_lc  = ua.toLowerCase()
let href = window.location.href
let vendor = navigator.vendor

let edge =   /edge\/\d+/.test(ua)
let ie11 =  (ua_lc.indexOf('trident') != -1 && ua.indexOf('rv:11') != -1)

let windows = /windows/.test(ua_lc)
let mac = /Apple Computer/.test(vendor)

//////let mobile =  /(iphone|ipad|ipod|android)/.test(ua_lc) //deprecated
let mobile_ua =  /mobile/.test(ua_lc)
let ios = (/(ios|ipad|iphone|ipod)/).test(ua_lc)
let android =  /android/.test(ua_lc)

//PHONE
let windows_phone = windows && mobile_ua
let android_phone = android && mobile_ua
let iphone = /iphone/.test(ua_lc)
let ipod = /ipod/.test(ua_lc)

let phone = (windows_phone || android_phone || iphone || ipod)
let mobile = phone

//TABLET
let android_tablet = (android && !mobile_ua)
let ipad = /ipad/.test(ua_lc)
let windows_tablet = (windows && /touch/.test(ua_lc) && !windows_phone)
  
let tablet = (android_tablet || ipad || windows_tablet)


//DESKTOP
let desktop = !(tablet || phone)


let desktop_safari = !ios && /safari/.test(ua_lc) && mac

let messenger = /fban\/messengerforios/.test(ua_lc) || /fb_iab\/messenger/.test(ua_lc)

var facebook_video_ad_urlparam = (window.location.href.indexOf("fbvideo")> -1);
let el_vh = document.createElement("div")
el_vh.style.cssText= `position: absolute;
                      pointer-events:none;
                      top:0px;
                      width:1px;
                      height:100vh;`
document.body.appendChild(el_vh)
let vh = el_vh.clientHeight
let facebook_video_ad = (ios)  ? (facebook_video_ad_urlparam && (window.screen.height - vh < 30))
  : (facebook_video_ad_urlparam && (window.screen.height - window.innerHeight) < 30);
document.body.removeChild(el_vh)

let facebook= (/(fban|fbav)/.test(ua_lc) && !messenger && !facebook_video_ad)

let instagram=  /instagram/.test(ua_lc)
let wechat =  /micromessenger/.test(ua_lc)
let weibo =  /weibo/.test(ua_lc)
let ucbrowser = /ucbrowser/.test(ua_lc)
let samsung =  /samsung/.test(ua_lc)

let other_ios_browsers = /(crios|fxios|opios|mercury|ucbrowser|fbav|fban|instagram)/.test(ua_lc)
let other_android_browsers = /(opera|ucbrowser|samsung|fbav|fban|instagram)/.test(ua_lc)

let ios_safari=  (ios &&  !other_ios_browsers)
let ios_chrome=   (ios &&  /crios/.test(ua_lc))

let android_chrome=  (android && !other_android_browsers &&  /chrome/.test(ua_lc)  && !messenger)


export default  {
  mobile,
  phone,
  
  tablet,
  desktop,
  
  ios,
  android,

  edge,
  ie11,

  desktop_safari,

  facebook_video_ad,
  facebook,
  messenger,
  instagram,

  wechat,
  weibo,
  ucbrowser,
  samsung,

  ios_safari,
  ios_chrome,

  android_chrome,

  windows,
  mac,

  windows_phone,
  android_phone,
  iphone,
  ipod,
  
  android_tablet,
  ipad,
  windows_tablet,
  
}

